import { useSelector } from 'react-redux';
import { selectorId } from 'selectors/payer';
import { selector as fspConfigPayALoanSelector } from 'selectors/fspConfigPayALoan';
import { isEnrolledOwner } from 'util/payerOwnerType';
import { isOn } from 'util/index';

/**
 * Enrolled payers only have Pay A Loan products, so their profile hides the
 * subpanels that do not apply to them. Returns false until the payer and the
 * pal config have loaded, which renders the existing full profile.
 */
const useEnrolledPayerProfile = (fspId, payerId) => {
  const payer = useSelector((state) => selectorId(state, payerId));
  const fspConfigPayALoan = useSelector((state) =>
    fspConfigPayALoanSelector(state, fspId)
  );

  return isEnrolledOwner(payer) && isOn(fspConfigPayALoan?.enrolledUserOffOn);
};

export default useEnrolledPayerProfile;
